import { Time } from "@angular/common";

export interface IMerchant {
  id: number;
  name: string;
  retialer_subdomain: string;
  active: boolean;
  logo: string;
  thumb_logo: string;
  phone_number: string;
  vat_number: string;
  description: string;
  website: string;
  created_at: Date;
  updated_at: Date;
  collect: boolean;
  deliver: boolean;
  take: boolean;
  collect_message: string;
  deliver_message: string;
  take_message: null;
  collect_policy: string;
  deliver_policy: string;
  take_policy: string;
  latitude: string;
  longitude: string;
  distance: null;
  address: Address;
  minimum_order_value: string;
  deliver_fee: string;
  radius: string;
  is_favourite: number;
  is_welcome_notification: number;
  wlcome_notification_text: string;
  wlcome_notification_header: string;
  wlcome_notification_image: string;
  serve_it: boolean;
  serve_policy: string;
  serve_message: string;
  serve_message_email: string;
  serve_proccesing_time: string;
  book_it: boolean;
  book_policy: null;
  book_message: null;
  book_message_email: null;
  book_proccesing_time: string;
  book_it_minimum_order_value: string;
  is_restricted: number;
  restricted_store_age_limit: number;
  is_restricted_store_popup_message: number;
  restricted_store_popup_message_header: string;
  restricted_store_popup_message_text: string;
  restricted_store_popup_message_image: string;
  webapp_settings: WebappSettings;
  deeplink: Deeplink;
  web_app_user: WebAppUser;
  showroom_shopping: boolean;
  allow_toodle_token: number;
  receipt_term_and_condition: string;
  currency: string;
  currency_decimals: number;
  assign_table: Table[];
  table: Table[];
  waiter: Waiter[];
  room: Room[];
  spreedly_gateway_type: string;
  waiter_notification_message: notificationmessage[];
  gateway_data: gateway_data;
  is_public_key_available: number;
  is_live_gateway_setup: number;
  welcome_notification_data: welcomeNotification;
  subdomain: string;
  headerImage: string;
  bannerImage: string;
  menu_color: string;
  menu_border_color: string;
  menu_border_width: number;
  menu_font_color_homepgae: string;
  menu_font_color_allpage: string;
  homepage_bottom_color: string;
  sale_suggest_discription: string;
  retailers_data: retailers_data[];
  multi_outlet: number;
  delivery_fee_apply: number;
}
export class Merchant implements IMerchant {
  fixed_processing_fixed: any;
  fixed_processing_fees_type: number;
  constructor() {
    this.webapp_settings = new WebappSettings();
  }
  id: number;
  name: string;
  retialer_subdomain: string;
  active: boolean;
  logo: string;
  headerLogo?: string;
  multioutlet_name?: string;
  multioutlet_menu_color?: string;
  multioutlet_menu_border_color?: string;
  multioutlet_headerImage?: string;
  multioutlet_headerLogo?: string;
  thumb_logo: string;
  phone_number: string;
  whatsapp_number: string;
  vat_number: string;
  description: string;
  website: string;
  privacy_policy_type: string;
  privacy_policy_type_code: number;
  privacy_policy_url: string;
  registered_business_address: string;
  created_at: Date;
  updated_at: Date;
  collect: boolean;
  deliver: boolean;
  take: boolean;
  collect_message: string;
  deliver_message: string;
  take_message: null;
  collect_policy: string;
  deliver_policy: string;
  take_policy: string;
  latitude: string;
  longitude: string;
  distance: null;
  address: Address;
  minimum_order_value: string;
  deliver_fee: string;
  radius: string;
  is_favourite: number;
  is_welcome_notification: number;
  wlcome_notification_text: string;
  wlcome_notification_header: string;
  wlcome_notification_image: string;
  serve_it: boolean;
  serve_policy: string;
  serve_message: string;
  serve_message_email: string;
  serve_proccesing_time: string;
  book_it: boolean;
  book_policy: null;
  book_message: null;
  book_message_email: null;
  book_proccesing_time: string;
  book_it_minimum_order_value: string;
  is_restricted: number;
  restricted_store_age_limit: number;
  is_restricted_store_popup_message: number;
  restricted_store_popup_message_header: string;
  restricted_store_popup_message_text: string;
  restricted_store_popup_message_image: string;
  welcome_notification_avaliable: number;
  welcome_notification_cooldown_interval: number;
  webapp_settings: WebappSettings;
  ecom_pre_paid;
  deeplink: Deeplink;
  web_app_user: WebAppUser;
  showroom_shopping: boolean;
  allow_toodle_token: number;
  receipt_term_and_condition: string;
  currency: string;
  currency_decimals: number;
  assign_table: Table[];
  table: Table[];
  waiter: Waiter[];
  room: Room[];
  spreedly_gateway_type: string;
  waiter_notification_message: notificationmessage[];
  gateway_data: gateway_data;
  is_public_key_available: number;
  is_live_gateway_setup: number;
  welcome_notification_data: welcomeNotification;
  welcome_notification_data_category_screen: welcomeNotification;

  error: string;
  success: number;
  subdomain: string;
  headerImage: string;
  bannerImage: string;
  menu_color: string;
  menu_border_color: string;
  menu_border_width: number;
  menu_font_color_homepgae: string;
  menu_font_color_allpage: string;
  homepage_bottom_color: string;
  sale_suggest_discription: string;
  retailers_data: retailers_data[];
  multi_outlet: number;
  delivery_fee_apply: number;
  bookit_fee_apply: number;
  serveit_fee_apply: number;
  popup_link: string;
  location_from: any;
  tile_text_color: any;
  popup_link_option;
  external_popup_link;
  external_pdf_document;
  external_whatsapp_link;
  custom_whatsapp_message;
  external_call_button;
  popup_header;
  popup_text;
  product_screen_template;
  is_outlet_level_login;
  processing_fees_percentage;
  processing_fees_amount;
  processing_fees_text;
  display_processing_fees;
  display_processing_fees_description;
  custom_login_popup_text;
  enable_location_selection_screen;
  display_contact_details_in_about;
  font_theme_selection;
  payar_mid;
  enable_feedback_form_whatsapp;
  enable_customer_feedback_form_whatsapp;
  google_tag_manager_id;
  should_show_save_button;
  enable_pwa_install_button;
  home_screen_layout;
  footer_bar_opacity;
  fullscreen_background_image;
}
export interface notificationmessage {
  id: number;
  message: string;
}
export interface retailers_data {
  retialer_name: string;
  retialer_subdomain: string;
  retialer_logo: string;
  retialer_description: string;
}
export interface Deeplink {
  deep_link_url: string;
  success: number;
  is_qr_order_online: number;
  description: string;
  logo: string;
}
export interface IAddress {
  id: number;
  name: string;
  line_1: string;
  line_2: string;
  city: string;
  county: string;
  district: string;
  country: string;
  postcode: string;
  coordinate: string;
  country_code: string;
  plus_code: string;
  district_id: number;
}
export class Address implements IAddress {
  id: number;
  name: string;
  line_1: string;
  line_2: string;
  city: string;
  county: string;
  district: string;
  country: string;
  postcode: string;
  coordinate: string;
  country_code: string;
  plus_code: string;
  district_id: number;
}
export interface WebAppUser {
  id: number;
  username: null;
  first_name: string;
  last_name: string;
  email: string;
  phone_number: null;
  account_verified: number;
  dob: null;
  verified_stores: any[];
  total_toodle_token: number;
}

interface IWebappSettings {
  id: number;
  retailer_id: number;
  menu_color: string;
  menu_border_color: string;
  menu_border_width: number;
  menu_font_color_homepgae: string;
  menu_font_color_allpage: string;
  home_page_banner_image: string;
  all_page_banner_image: string;
  pay_with_toodle: number;
  charge_to_room: number;
  pay_by_card_terminal: number;
  pay_cash: number;
  pay_with_toodle_dynamic_text: string;
  charge_to_room_dynamic_text: string;
  pay_by_card_terminal_dynamic_text: string;
  pay_cash_dynamic_text: string;
  pay_with_toodle_aditional_dynamic_text: string;
  bank_transfer: number;
  bank_transfer_dynamic_text: string;
  brunch_package: number;
  brunch_package_dynamic_text: string;
  all_inclusive: number;
  all_inclusive_dynamic_text: string;
  full_board: number;
  full_board_dynamic_text: string;
  half_board: number;
  half_board_dynamic_text: string;
  paid_with_apple_pay: number;
  paid_with_apple_pay_dynamic_text: string;
  is_waiter: number;
  is_table: number;
  is_room: number;
  is_deeplink: number;
  Deeplinkurl: string;
  is_enable_promocode: number;
  is_notification_enable: number;
  open_time_slot: Time;
  close_time_slot: Time;
  web_app_online: number;
  webapp_close_dynamic_text: string;
  webapp_close_order_place_dynamic_text: string;
  is_daywise_slot: number;
  is_non_clickable_product: number;
  is_non_clickable_product_outlet: number;
  is_scan_webapp: number;
  distance: number;
  paid_with_token: number;
  paid_with_token_dynamic_text: string;
  is_receipt_activate: number;
  homepage_bottom_color: string;
  is_login_registration_allowed: number;
  groupon: number;
  groupon_dynamic_text: string;
  the_entertainer: number;
  the_entertainer_dynamic_text: string;
  pay_in_app_online: number;
  pay_in_app_online_dynamic_text: string;
  enable_fullfillment_online_and_showroom_webapp: number;
  pay_in_store_totally_wicked: number;
  pay_in_store_totally_wicked_dynamic_text: string;
  enable_serve_webapp_location_service: number;
  dynamic_text_for_promotional_category: string;
  guest_access_allowed: number;
  is_user_browser_location_on: number;
  is_guest_email: number;
  is_guest_phone: number;
  enable_welcome_notification: number;
  show_product_image: number;
  show_promotional_category: number;
  is_collect: number;
}
export class WebappSettings implements IWebappSettings {
  constructor() {
    this.is_room = 0;
  }
  id: number;
  retailer_id: number;
  menu_color: string;
  menu_border_color: string;
  menu_border_width: number;
  menu_font_color_homepgae: string;
  menu_font_color_allpage: string;
  home_page_banner_image: string;
  all_page_banner_image: string;
  pay_with_toodle: number;
  charge_to_room: number;
  pay_by_card_terminal: number;
  pay_cash: number;
  pay_with_toodle_dynamic_text: string;
  charge_to_room_dynamic_text: string;
  pay_by_card_terminal_dynamic_text: string;
  pay_cash_dynamic_text: string;
  pay_with_toodle_aditional_dynamic_text: string;
  bank_transfer: number;
  bank_transfer_dynamic_text: string;
  brunch_package: number;
  brunch_package_dynamic_text: string;
  all_inclusive: number;
  all_inclusive_dynamic_text: string;
  full_board: number;
  full_board_dynamic_text: string;
  half_board: number;
  half_board_dynamic_text: string;
  payment_link_dynamic_text: string;
  paid_with_apple_pay: number;
  paid_with_apple_pay_dynamic_text: string;
  is_waiter: number;
  is_table: number;
  is_room: number;
  is_deeplink: number;
  Deeplinkurl: string;
  is_enable_promocode: number;
  is_notification_enable: number;
  open_time_slot: Time;
  close_time_slot: Time;
  web_app_online: number;
  webapp_close_dynamic_text: string;
  webapp_close_order_place_dynamic_text: string;
  is_daywise_slot: number;
  is_non_clickable_product: number;
  is_non_clickable_product_multi_outlet: number;
  is_non_clickable_product_outlet: number;
  is_scan_webapp: number;
  distance: number;
  paid_with_token: number;
  paid_with_token_dynamic_text: string;
  is_receipt_activate: number;
  homepage_bottom_color: string;
  is_login_registration_allowed: number;
  groupon: number;
  groupon_dynamic_text: string;
  the_entertainer: number;
  the_entertainer_dynamic_text: string;
  pay_in_app_online: number;
  pay_in_app_online_dynamic_text: string;
  enable_fullfillment_online_and_showroom_webapp: number;
  pay_in_store_totally_wicked: number;
  pay_in_store_totally_wicked_dynamic_text: string;
  enable_serve_webapp_location_service: number;
  guest_access_allowed: number;
  is_user_browser_location_on: number;
  is_guest_email: number;
  is_guest_phone: number;
  enable_welcome_notification: number;
  dynamic_text_for_promotional_category: string;
  minimum_order_value: number;
  show_product_image: number;
  show_promotional_category: number;
  is_collect: number;
  is_tips_enable: number;
  product_screen_template: number;
  categories_screen_template: number;
  is_enable_tip: number;
  is_enable_referral_code: boolean;
  enable_location_selection_screen;
  font_theme_selection;
  enable_pwa_install_button: number;
  home_screen_layout: number;
  footer_bar_opacity: number;
  fullscreen_background_image: string;
  show_shadow_effect: boolean;
}
export interface Table {
  id: number;
  name: string;
  description: string;
}

export interface IGatewayData {
  version: string;
  public_key: string;
  merchant_id: string;
  applepay_merchant_id: string;
  gpay_merchant_id: string;
}
export class gateway_data implements IGatewayData {
  version: string;
  public_key: string;
  merchant_id: string;
  applepay_merchant_id: string;
  gpay_merchant_id: string;
}
export interface Waiter {
  id: number;
  name: string;
  email: string;
  dial_code: string;
  phone_number: string;
  waiter_id: string;
}
export interface Room {
  id: number;
  name: string;
  description: string;
}
export interface welcomeNotification {
  wlcome_notification_text: string;
  wlcome_notification_header: string;
  wlcome_notification_image: any;
  subdomain: string;
  wlcome_notification_id?: number;
  show_logged_in_only: number; // 0 = all users, 1 = only logged-in
  login_trigger_type: number; // 1 = direct, 2 = session-based
  min_sessions: number | null;
  popup_content_type: number;
}
